// extracted by mini-css-extract-plugin
export default {"item":"PreferencesList_item__1ai-H","handle":"PreferencesList_handle__3L8zS","value":"PreferencesList_value__E0b2i"};